/* Code generated with AutoHTML Plugin for Figma */
import { STATIC_HM_PATH } from "@project/shared-types";
import { Link } from "../../components/link/link";
import { Label } from "../../components/texts/label";
import { Text } from "../../components/texts/text";
import Title from "../../components/texts/title";

import {
  _colorText,
  _size,
  _sizeHeading,
  _sizeText,
  _typeLabel,
} from "../../core/core";
import { BlockBase } from "../BlockBase/BlockBase";
import "./workpromo.css";

export const WorkPromo = ({ ...props }) => {
  return (
    <BlockBase>
      <div className="work-header">
        <Title type={_sizeHeading.h2}>Хочешь заработать? Лови задания</Title>
      </div>
      <div className="work-items">
        <div className="work-item">
          <div className="work-item-t">
            <Title type={_sizeHeading.h3}>Отдельная платформа для работы</Title>
            <div className="big-card-info-t">
              <div className="big-card-row">
                <div className="frame-2043683380">
                  <div className="ellipse-84"></div>
                </div>
                <Text color={_colorText.black} size={_sizeText.m}>
                  • Для удобного выполнения заданий мы разработали отдельное
                  приложение, где вы быстро сможете выполнять задания
                </Text>
              </div>
              <div className="big-card-row">
                <div className="frame-2043683380">
                  <div className="ellipse-84"></div>
                </div>
                <Text color={_colorText.black} size={_sizeText.m}>
                  • Есть обучающие материалы в которых подробно описан каждый
                  шаг, для успешного выполнения зададания
                </Text>
              </div>
            </div>
          </div>
          <div className="work-item-d">
            <Label type={_typeLabel.neutral} size={_size.M}>
              #удобно
            </Label>
            <Label type={_typeLabel.neutral} size={_size.M}>
              #просто
            </Label>
          </div>
        </div>
        <div className="work-item">
          <div className="work-item-t work-item-r ">
            <Title type={_sizeHeading.h3}>Приемущества платформы</Title>
            <div className="work-item-t-g">
              <Text color={_colorText.black} size={_sizeText.m}>
                • Для работы нужен только интернет и телефон
              </Text>
              <Text color={_colorText.black} size={_sizeText.m}>
                • На платформе ежедневно появляется более 100 заданий
              </Text>
              <Text color={_colorText.black} size={_sizeText.m}>
                • Еженедельные выплаты
              </Text>
            </div>
          </div>
          <Link
            blank
            size={_size.M}
            width={"100%"}
            link={
              "https://viw.im/ispolniteli/?utm_source=hm_new&utm_medium=workpromo&utm_campaign=17052023&utm_content=link"
            }
          >
            Начать выполнять
          </Link>
          <img
            className="work-item-img "
            alt="промо VIWORK"
            src={`${STATIC_HM_PATH}/images/WorkPromo.webp`}
          ></img>
        </div>
      </div>
    </BlockBase>
  );
};
